import { useEffect } from 'react';
import { useServices } from 'core/common/hooks';
import { PaymentError } from 'core/payments/entities';
import {
  useThreeDomainSecurePayment,
  useThreeDomainSecurePaymentListener,
} from 'core/payments/hooks';

type Params = {
  onSucceed?: () => void;
};

export const usePaymentThreeDomainSecure = ({ onSucceed }: Params) => {
  const { analyticsService } = useServices();

  const { paymentProcessingData, paymentFormFailed, paymentFormSucceed } =
    useThreeDomainSecurePayment();

  const paymentSucceed = () => {
    analyticsService.trackEvent('funnel_modal_open', { screen_context: '3ds', value: 'success' });

    if (onSucceed) {
      onSucceed();
    }

    paymentFormSucceed();
  };

  const paymentFailed = (error: PaymentError) => {
    analyticsService.trackEvent('funnel_modal_open', { screen_context: '3ds', value: 'error' });

    paymentFormFailed(error);
  };

  useThreeDomainSecurePaymentListener({ paymentSucceed, paymentFailed });

  useEffect(() => {
    analyticsService.trackEvent('funnel_modal_open', { screen_context: '3ds' });
  }, [analyticsService]);

  return {
    paymentProcessingData,
  };
};
